<template>
    <header>
      <a v-if="show === 'account' && $store.getters.windowWidth > $breakpoints.list.s" href="/app" class="link link-semibold">
        <span>Mon compte</span>
        <Icon name="account"/>
      </a>
      <a v-if="show === 'login' && $store.getters.windowWidth > $breakpoints.list.s" href="/auth/connexion" class="link link-semibold">
        <span>Connexion</span>
        <Icon name="account"/>
      </a>
    </header>
</template>

<script>
export default {
    data() {
        return {
            show: ''
        };
    },
    mounted() {
        if (process.client) {
            let { cookie } = require('~/plugins/cookie');
            this.show = cookie.get('psu') ? 'account' : 'login';
        }
    }
};
</script>

<style lang="scss" scoped>
header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    padding: 0 $gutter;
    z-index: 1;
    ul {
        margin: 0;
        list-style-type: none;
    }
    .link {
        flex-direction: row-reverse;
        color: $white;
        text-decoration: none;
        .icon {
            width: 1em;
            height: 1em;
            margin-right: $gutter;
        }
    }
}
</style>
